import script from "./ExamplePage,.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamplePage,.vue?vue&type=script&setup=true&lang=js"

import "./ExamplePage,.vue?vue&type=style&index=0&id=6e0c9400&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e0c9400"]])

export default __exports__